 
import { default as ArticleBatchWorker } from 'app/modules/wallforming/components/workers/articleBatchPreparation.worker?worker';

import { createSingleTaskWorker } from 'app/modules/wallforming/components/workers/createWorkerSingleton';

const articleBatchWorker = createSingleTaskWorker<unknown, unknown>(
    () => new ArticleBatchWorker(),
    'ArticleBatchWorker'
);

export const acquireArticleBatchWorker = (): void => articleBatchWorker.acquire();
export const releaseArticleBatchWorker = (): void => articleBatchWorker.release();

export function postArticleBatchTask<T>(data: unknown): Promise<T> {
    return articleBatchWorker.postTask(data) as Promise<T>;
}
